<div class="forgot-password-screen">
  <mat-grid-list [cols]="1">
    <div class="center-column mat-padding">
      <huge-row class="mat-padding">
        <mat-col>
          <img src="assets/img/hugeconnect.png" alt="logo" class="hugeLogo" />
        </mat-col>
      </huge-row>
      <huge-row class="forgot-heading">
        <mat-col>
          <p class="identity-card-title"> Forgot Password </p>
        </mat-col>
      </huge-row>
      <div class="card wrapper center-column mat-padding">
        <huge-row class="card-heading">
          <mat-col class="text-align-center">
            <p class="identity-card-subtitle"> Please enter your email so that we can send you a reset link: </p>
          </mat-col>
        </huge-row>
        <form [formGroup]="ionicFormGroup" class="form-container">
          <mat-list-item class="form-field-width">
            <mat-form-field class="full-width">
              <mat-label position="floating" class="form-label">Email</mat-label>
              <input matInput type="email" formControlName="emailControl" (keyup.enter)="getPasswordClicked()" required />
            </mat-form-field>
          </mat-list-item>
          <div>
            @for (validation of validation_messages.emailControl; track validation) { @if ( validations_form.get('emailControl')?.hasError(validation.type) &&
            (validations_form.get('emailControl')?.dirty || validations_form.get('emailControl')?.touched) ) {
            <div class="validation-error-message">
              {{ validation.message }}
            </div>
            } }
          </div>
        </form>
        <huge-row class="mat-margin-top">
          <mat-col>
            <button class="btn primary-btn" (click)="getPasswordClicked()">Send Reset Email</button>
            <button class="btn secondary-btn" (click)="cancel()">Cancel</button>
          </mat-col>
        </huge-row>
        <br />
      </div>
    </div>
  </mat-grid-list>
</div>
